import { handleActions, ActionMeta } from "redux-actions";
import {
    DASHBOARD,
    DASHBOARD_FETCH,
    DASHBOARD_LINESHEETS_FETCHED,
    SET_RECENTLY_TEXT_EDITOR,
} from "constants/action-types";
import { List } from "immutable";

export interface IData {
    url?: string;
    title?: string;
    image?: string;
    [propName: string]: any;
}

export interface IState {
    pageId?: string;
    layoutId?: string | null; // undefined = fetching, null = need to create one, obj = has one
    pendingUploadId?: string;
    error?: string;
    linesheetIds?: List<string>;
    recentlyTextEditorIdAdded?: string;
}

export type TFetch = ActionMeta<
    any | null,
    {
        pageId?: string;
    }
>;

const initialState: IState = {
    layoutId: undefined,
    linesheetIds: undefined,
    pendingUploadId: undefined,
    error: undefined,
    recentlyTextEditorIdAdded: null,
};

const dashboardReducer = handleActions<IState, any>(
    {
        [DASHBOARD_FETCH]: (state: IState, action: TFetch): IState => {
            const { error, meta, payload } = action;
            return {
                ...state,
                ...meta,
                layoutId: error ? null : payload,
                linesheetIds: null,
            };
        },
        [DASHBOARD.PENDING_MEDIA.UPLOADED]: (state: IState, { payload }): IState => ({
            ...state,
            pendingUploadId: payload,
        }),
        [DASHBOARD.PENDING_MEDIA.CLEAR]: (state: IState): IState => ({
            ...state,
            pendingUploadId: undefined,
        }),
        [DASHBOARD.PENDING_MEDIA.ERROR]: (state: IState, { payload }): IState => ({
            ...state,
            error: payload,
        }),
        [DASHBOARD_LINESHEETS_FETCHED]: (state: IState, { payload }): IState => {
            return {
                ...state,
                pendingUploadId: payload,
            };
        },
        [DASHBOARD.CLEAR]: (): IState => initialState,
        [SET_RECENTLY_TEXT_EDITOR]: (state: IState, { payload }: any): IState => {
            return {
                ...state,
                recentlyTextEditorIdAdded: payload.id,
            };
        },
    },
    initialState,
);

export default dashboardReducer;
